<template>
  <transition
    name="s-zoom-in-bottom">
    <div
      v-if="value"
      class="comments">
      <div style="overflow: hidden;">
        <div
          class="comments-title">
          {{ value.title }}
        </div>
        <slot name="message">
          <div
            v-dompurify-html="value.text"
            class="comments-text"/>
        </slot>
      </div>
      <sButton
        :disabled="loading"
        icon="cross"
        icon-size="10px"
        small
        type="text"
        @click="$emit('close')"/>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'commentInputBlock',
  props: {
    value: {
      type: Object
    },
    loading: {
      type: Boolean
    }
  },
}
</script>
<style scoped lang="scss">
.comments {
  box-shadow: 0px -3px 9px -5px black !important;
  padding: 5px 10px;
  position: absolute;
  top: -42px;
  left: 8px;
  right: 8px;
  background: var(--green_chosen_light);
  display: flex;
  justify-content: space-between;
  text-align: left;
  &-title {
    font-weight: 500;
    font-size: 11px;
    line-height: 12px;
  }
  &-text {
    font-size: 11px;
    line-height: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
